import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memoForwardRef } from "@shared/client/util/memo";
import { useApp } from "@/state/app-context";
import "./main-slate.scss";
export const MainSlate = memoForwardRef(({ header, content, omnibar }, ref) => {
    const app = useApp();
    const streamFadeOpacity = app.useStore((s) => s.ui.streamFadeOpacity);
    // Stack-isolation mode: an open stack + a focused omnibar puts the
    // user squarely in "rapid-fire captures into THIS stack" intent.
    // Surface a data attribute the stream SCSS keys off to dim every
    // sibling card down to a barely-there 0.24 — the open stack tile
    // and its unfurled members stay at full opacity so the destination
    // of the in-flight capture is unambiguous. Computed on the store
    // (rather than threaded through a context) so the rule is one
    // selector update away from any future stream surface that mounts
    // under the slate.
    const isStackIsolationActive = app.useStore((s) => s.ui.isOmnibarFocused && s.ui.openStackId !== undefined);
    // Surface the fade-opacity setting as a CSS variable so SCSS can dim
    // `.main-slate__content-area` without React having to inline a style on
    // the inner element.
    const slateStyle = {
        "--stream-fade-opacity": streamFadeOpacity,
    };
    return (_jsxs("div", { ref: ref, className: "main-slate", style: slateStyle, "data-stack-isolation": isStackIsolationActive ? "" : undefined, children: [header, _jsxs("div", { className: "main-slate__body", children: [_jsx("div", { className: "main-slate__content-area", children: content }), omnibar] })] }));
});
